import { fetchPropertyAddressSuggestions } from '@app/services/propertyService'
import { PropertySuggestion } from '../types'
import { useQuery } from '@tanstack/react-query'

export const useFetchPropertySuggestions = (
  assetType: string | undefined,
  searchQuery: string,
  enabled = false,
) => {
  return useQuery<PropertySuggestion[]>({
    queryKey: [`property suggestion`, assetType, searchQuery],
    queryFn: ({ signal }) => {
      if (!assetType) throw new Error('assetType is required')
      return fetchPropertyAddressSuggestions(assetType, searchQuery, signal)
    },
    enabled: enabled && !!assetType,
  })
}
